import { render, staticRenderFns } from "./cameraComponent.pug?vue&type=template&id=7178540a&lang=pug&external"
import script from "./cameraComponent.js?vue&type=script&lang=js&external"
export * from "./cameraComponent.js?vue&type=script&lang=js&external"
import style0 from "./cameraComponent.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7178540a')) {
      api.createRecord('7178540a', component.options)
    } else {
      api.reload('7178540a', component.options)
    }
    module.hot.accept("./cameraComponent.pug?vue&type=template&id=7178540a&lang=pug&external", function () {
      api.rerender('7178540a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cameraComponent/index.vue"
export default component.exports